document.addEventListener("DOMContentLoaded", () => {
    const currentDate = new Date();
    const popupStartDate = new Date("2026-09-17T00:00:00");
    const popupEndDate = new Date("2026-09-23T23:59:59");
    const devMode = localStorage.getItem("sandsDevMode");

    if (!devMode && (currentDate < popupStartDate || currentDate > popupEndDate)) {
        document.querySelector(".sands-popup-saudiday")?.remove();
        return;
    }

    const dismissOnUserScroll = (event) => {
        if (
            event.type === "keydown" &&
            !["ArrowDown", "ArrowUp", "PageDown", "PageUp", "Home", "End", " "].includes(
                event.key,
            )
        ) {
            return;
        }

        document.querySelector(".sands-popup-saudiday")?.classList.remove("reveal");
        window.removeEventListener("wheel", dismissOnUserScroll);
        window.removeEventListener("touchstart", dismissOnUserScroll);
        window.removeEventListener("keydown", dismissOnUserScroll);
    };

    window.addEventListener("wheel", dismissOnUserScroll, { passive: true });
    window.addEventListener("touchstart", dismissOnUserScroll, { passive: true });
    window.addEventListener("keydown", dismissOnUserScroll);
});